import { FC } from 'react';

import { StyledOverlay } from './Overlay.styles';

export const Overlay: FC = () => (
	<StyledOverlay>
		<div />
	</StyledOverlay>
);
